// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3RJUv","bigColWidth":"Table_bigColWidth__RUyuf","biggerColWidth":"Table_biggerColWidth__1f8VQ","row":"Table_row__fB69x","col":"Table_col__2_0eY"};